// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vobK","col":"styles_col__1Umaq"};